module.exports = __webpack_public_path__ + "img/calculator.ac024188.png";